module.exports = __webpack_public_path__ + "img/google_cs.2f494727.webp";